'use strict';

exports.__esModule = true;
exports['default'] = void 0;

// @private
function capitalizeString(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

var _default = capitalizeString;
exports['default'] = _default;
module.exports = exports.default;
